import UserList, { Candidate } from '~/components/UserList';
import { FormattedMessage, useIntl } from 'react-intl';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useSettingsByCategory } from '~/hooks/api/useSettingsByCategory';
import { Stack } from '@mui/system';
import messages from '../messages';
import RevokePublisherShiftApplicationButton from '../RevokePublisherShiftApplicationButton';

type ListItemActionsProps = {
  candidate: Candidate;
  onAssignCandidate: (applicationId: number) => void;
  shiftId: number;
  turnId: number;
};

const ListItemActions = (props: ListItemActionsProps) => {
  const intl = useIntl();
  return (
    <>
      {props.candidate.application.turn == null &&
        props.candidate.application.plannedTurn == null && (
          <RevokePublisherShiftApplicationButton
            publisherName={`${props.candidate.application.publisher.firstName} ${props.candidate.application.publisher.lastName}`}
            shiftApplicationId={props.candidate.application.id}
            shiftId={props.shiftId}
            turnId={props.turnId}
          />
        )}
      <IconButton
        onClick={() => props.onAssignCandidate(props.candidate.application.id)}
        size="large"
        aria-label={intl.formatMessage(messages.assignPublisher, {
          firstName: props.candidate.application.publisher.firstName,
          lastName: props.candidate.application.publisher.lastName,
        })}
      >
        <KeyboardArrowRight />
      </IconButton>
    </>
  );
};

type UnassignedPublishersProps = {
  appliedCandidates: Candidate[];
  onAssignCandidate: (applicationId: number) => void;
  shiftId: number;
  turnId: number;
};

const UnassignedPublishers = (props: UnassignedPublishersProps) => {
  const { data: settings } = useSettingsByCategory('participation');
  if (!props.appliedCandidates || !settings) {
    return null;
  }
  return settings.allowPublishersToMaintainRoutePreferences ? (
    <Stack>
      <UserList
        isCollapsible={false}
        isOpen
        onToggle={() => {}}
        renderListItemAction={(candidate) => (
          <ListItemActions
            candidate={candidate as Candidate}
            onAssignCandidate={props.onAssignCandidate}
            shiftId={props.shiftId}
            turnId={props.turnId}
          />
        )}
        candidates={props.appliedCandidates.filter(
          (candidate) => candidate.preference === 0
        )}
        title={<FormattedMessage {...messages.preferThisRoute} />}
      />
      <Divider />
      <UserList
        isCollapsible={false}
        isOpen
        onToggle={() => {}}
        renderListItemAction={(candidate) => (
          <ListItemActions
            candidate={candidate as Candidate}
            onAssignCandidate={props.onAssignCandidate}
            shiftId={props.shiftId}
            turnId={props.turnId}
          />
        )}
        candidates={props.appliedCandidates.filter(
          (candidate) => candidate.preference === 1
        )}
        title={<FormattedMessage {...messages.neutralTowardsThisRoute} />}
      />
      <Divider />
      <UserList
        isCollapsible={false}
        isOpen
        onToggle={() => {}}
        renderListItemAction={(candidate) => (
          <ListItemActions
            candidate={candidate as Candidate}
            onAssignCandidate={props.onAssignCandidate}
            shiftId={props.shiftId}
            turnId={props.turnId}
          />
        )}
        candidates={props.appliedCandidates.filter(
          (candidate) => candidate.preference === 2
        )}
        title={<FormattedMessage {...messages.preferNotToGoOnThisRoute} />}
      />
    </Stack>
  ) : (
    <UserList
      isCollapsible={false}
      isOpen
      onToggle={() => {}}
      renderListItemAction={(candidate) => (
        <ListItemActions
          candidate={candidate as Candidate}
          onAssignCandidate={props.onAssignCandidate}
          shiftId={props.shiftId}
          turnId={props.turnId}
        />
      )}
      candidates={props.appliedCandidates}
      title={<FormattedMessage {...messages.applications} />}
    />
  );
};

export default UnassignedPublishers;
